/**
 * Viewport and scroll-driven lifecycle hooks, split out of ./runner.
 *
 * These are the only hooks that need Observe and Track, and Track reaches
 * @lib/scroll, which reaches Lenis and the full @lib/gsap plugin set. Keeping
 * them here means a per-page bundle can import the plain lifecycle hooks from
 * ./runner without dragging ~140KB of scroll machinery in behind them.
 *
 * The "@/modules/_" barrel re-exports both, so nothing that imports from the
 * barrel needs to change.
 */
import { Observe, ObserveConfig } from "./observe";
import { Track } from "./track";
import { onDestroy } from "./runner";

export function onView(
  element: HTMLElement,
  { root, rootMargin, threshold, autoStart, once, callback }: ObserveConfig
) {
  const observer = new Observe(element, {
    root,
    rootMargin,
    threshold,
    autoStart,
    once,
    callback,
  });

  onDestroy(() => {
    observer.destroy();
  });

  return observer;
}

export function onTrack(
  element: HTMLElement,
  config: {
    bounds?: [number, number];
    top?: "top" | "center" | "bottom";
    bottom?: "top" | "center" | "bottom";
    callback?: (value: number) => void;
  } = {}
) {
  const track = new Track(element, config);

  onDestroy(() => {
    track.destroy();
  });

  return track;
}
